import apiClient from '../client';
import { ApiResponse, ImportReport, FormImport } from '@/types';

export const importApi = {
  uploadJson: async (file: File): Promise<ImportReport> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ApiResponse<ImportReport>>('/import/json', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data!;
  },

  getHistory: async (): Promise<FormImport[]> => {
    const response = await apiClient.get<ApiResponse<FormImport[]>>('/import/history');
    return response.data.data ?? [];
  },

  getStats: async (): Promise<{ schools: number; participants: number; imports: number }> => {
    const response = await apiClient.get<ApiResponse<{ schools: number; participants: number; imports: number }>>('/import/stats');
    return response.data.data!;
  },
};
